import React, { useState, useEffect } from 'react';
import { useSettingsStyles } from './styles';
import { saveAnnouncement, getAnnouncement, savePodNews, getPodNews } from '../api/podcasts';

export const Settings = () => {
  const classes = useSettingsStyles();
  const [announcement, setAnnouncement] = useState('');
  const [podNews, setPodNews] = useState();
  const [isLoadingAnnouncement, setIsLoadingAnnouncement] = useState(false);
  const [isLoadingPodNews, setIsLoadingPodNews] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [announcementData, podNewsData] = await Promise.all([
          getAnnouncement(),
          getPodNews(),
        ]);
        setAnnouncement(announcementData.announcement);
        setPodNews(podNewsData.podNews);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to fetch data');
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  }, []);

  const handleAnnouncementChange = (e) => {
    setAnnouncement(e.target.value);
  };

  const handlePodNewsChange = (e) => {
    setPodNews((prev) => ({
      ...prev,
      text: e.target.value,
    }));
  };

  const handleAnnouncementSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingAnnouncement(true);
    setError(null);

    try {
      await saveAnnouncement(announcement);
      console.log('Announcement saved successfully');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save announcement');
      console.error('Error saving announcement:', err);
    } finally {
      setIsLoadingAnnouncement(false);
    }
  };

  const handlePodNewsSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingPodNews(true);
    setError(null);

    try {
      await savePodNews(podNews);
      console.log('Pod News saved successfully');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save pod news');
      console.error('Error saving pod news:', err);
    } finally {
      setIsLoadingPodNews(false);
    }
  };

  return (
    <div className={classes.container}>
      <h1>Settings</h1>
      {error && <div className={classes.error}>{error}</div>}

      <form onSubmit={handleAnnouncementSubmit}>
        <div className={classes.formGroup}>
          <label htmlFor="announcement" className={classes.label}>
            Announcement
          </label>
          <textarea
            id="announcement"
            value={announcement}
            onChange={handleAnnouncementChange}
            rows={4}
            placeholder="Enter announcement text..."
            className={classes.textarea}
          />
          <button type="submit" className={classes.saveButton} disabled={isLoadingAnnouncement}>
            {isLoadingAnnouncement ? 'Saving...' : 'Save Announcement'}
          </button>
        </div>
      </form>

      <form onSubmit={handlePodNewsSubmit}>
        <div className={classes.formGroup}>
          <label htmlFor="podNews" className={classes.label}>
            Pod News
          </label>
          <textarea
            id="podNews"
            value={podNews?.text || ''}
            onChange={handlePodNewsChange}
            rows={4}
            placeholder="Enter pod news text..."
            className={classes.textarea}
          />
          <button type="submit" className={classes.saveButton} disabled={isLoadingPodNews}>
            {isLoadingPodNews ? 'Saving...' : 'Save Pod News'}
          </button>
        </div>
      </form>
    </div>
  );
};
